import React = require('react');
import { FaSpinner } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

export const CancellationButton = ({handleCancelSelected, calculating}) => {

  const handleOnClick = () => {
    handleCancelSelected();
  }

  return (
    <Button
      bsStyle="primary"
      type="button"
      bsSize="small"
      block={true}
      className={'functional-button'}
      onClick={handleOnClick}
      disabled={calculating}>
      {calculating && (
        <FaSpinner className="fa-spin"/>
      )}
      CANCEL COVER
    </Button>
  )
}
